import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../services/api.auth";

function buildWebListFormData(form, imageFile) {
  const formData = new FormData();
  formData.append("name", form.name);
  formData.append("link1name", form.link1name);
  formData.append("link1url", form.link1url);
  formData.append("link2name", form.link2name);
  formData.append("link2url", form.link2url);
  formData.append("introtext", form.introtext);
  if (imageFile) {
    formData.append("image", imageFile);
  }
  return formData;
}

function Add() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    link1name: "",
    link1url: "",
    link2name: "",
    link2url: "",
    introtext: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    setImageFile(file);
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(file ? URL.createObjectURL(file) : null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const formData = buildWebListFormData(form, imageFile);
      await API.post("/webList", formData);
      navigate("/AdminHomeScreen");
    } catch (err) {
      const data = err?.response?.data;
      let message =
        data?.message ||
        (typeof data === "string" ? data : "") ||
        err?.message ||
        "Failed to add weblist";
      if (data?.errors && typeof data.errors === "object") {
        const first = Object.values(data.errors).flat()[0];
        if (first) message = first;
      }
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-card">
      <h2>Add Weblist</h2>

      {error ? <div className="error-banner">{error}</div> : null}

      <form onSubmit={handleSubmit} className="form-grid">
        <div className="field field-full">
          <label htmlFor="add-image">Image</label>
          <input
            id="add-image"
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            onChange={handleFileChange}
          />
          <p className="field-hint">JPEG, PNG, WebP, or GIF — max 2 MB</p>
          {previewUrl ? (
            <div className="profile-preview">
              <img src={previewUrl} alt="" />
            </div>
          ) : null}
        </div>

        <div className="field">
          <label>Name</label>
          <input
            placeholder="Name"
            value={form.name}
            onChange={handleChange("name")}
            required
          />
        </div>

        <div className="field">
          <label>Link 1 Name</label>
          <input
            placeholder="link1name"
            value={form.link1name}
            onChange={handleChange("link1name")}
          />
        </div>

        <div className="field">
          <label>Link 1 Url</label>
          <input
            placeholder="link1url"
            value={form.link1url}
            onChange={handleChange("link1url")}
          />
        </div>

        <div className="field">
          <label>Link 2 Name</label>
          <input
            placeholder="link2name"
            value={form.link2name}
            onChange={handleChange("link2name")}
          />
        </div>

        <div className="field">
          <label>Link 2 Url</label>
          <input
            placeholder="link2url"
            value={form.link2url}
            onChange={handleChange("link2url")}
          />
        </div>

        <div className="field">
          <label>Intro Text</label>
          <input
            placeholder="introtext"
            value={form.introtext}
            onChange={handleChange("introtext")}
          />
        </div>

        <button type="submit" disabled={submitting}>
          {submitting ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
}

export default Add;
